// MeetLiveCaptions — overlay at the bottom of VideoRoom that shows the most
// recent N transcript utterances for the active room. Reads directly from
// root.utterances which is populated by the page-level subscribeMeetRealtime
// (see pages/meet.js). Hidden when the active room isn't transcribed or
// when there are no utterances yet.
import { speakerDisplayName } from '../../functions/meet/meetUtils.js'

const MAX_VISIBLE = 3

export const MeetLiveCaptions = {
  hide: (el, s) => {
    const room = (s.root?.rooms || []).find(r => r.id === s.root?.activeRoomId)
    if (!room?.transcribeEnabled) return true
    if (s.root?.showLiveCaptions === false) return true
    const utts = (s.root?.utterances || []).filter(u => u.roomId === s.root?.activeRoomId)
    return utts.length === 0
  },
  position: 'absolute',
  bottom: 'D',
  left: 'A',
  right: 'A',
  pointerEvents: 'none',
  flow: 'y',
  gap: 'V',

  childExtends: 'MeetCaptionLine',
  childrenAs: 'state',
  children: (el, s) => {
    const utts = (s.root?.utterances || []).filter(u => u.roomId === s.root?.activeRoomId)
    return utts.slice(-MAX_VISIBLE)
  }
}

export const MeetCaptionLine = {
  flow: 'x',
  gap: 'Z',
  padding: 'Z A',
  round: 'Z',
  background: 'black.7',
  backdropFilter: 'blur(8px)',
  color: 'white',
  fontSize: 'Z2',
  alignSelf: 'center',
  maxWidth: 'I',

  Speaker: {
    tag: 'span',
    fontWeight: '600',
    color: 'cyan',
    text: (el, s) => speakerDisplayName(s.root, s.speakerEmail) + ':'
  },
  Text: {
    tag: 'span',
    flex: '1',
    text: (el, s) => s.text || ''
  }
}
